import { getServiceName } from './getServiceName';

const useService = () => {
  const serviceName = getServiceName();
  const isBubbleChatService = serviceName === 'bubblechat';
  const productName = isBubbleChatService ? 'Shampoo' : 'Portion';
  const creditName = isBubbleChatService ? 'Bubble' : 'Point';

  return {
    serviceName,
    productName,
    creditName,
  };
};

export default useService;
